// extracted by mini-css-extract-plugin
export default {"componentList":"ComponentList_componentList__2fHb0","componentList__item":"ComponentList_componentList__item__H7Irm"};